import BaseEntity from '../base/BaseEntity.model';
import Documento from '../documento.model';

export default class TramiteBeneficiarioDocumento extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public documentoId?: number;
    public documento?: Documento;

    constructor(public tipoDocumentoId?: number, public tipoDocumentoNombre?: string){
        super();
        this.tramiteBeneficiarioId = undefined;
        this.documento = undefined;
        this.documentoId = undefined;
    }
}